export default __webpack_public_path__ + "4386fa9c7f4584d51881ec4c4ed4e101.png";